import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Card, Input, Button } from '@getpay93/ui';
import type { PublicInvite } from '@getpay93/api';
import { api } from '../lib/api';
import { useAuth } from '../auth/AuthContext';
import { homePathFor } from '../auth/session';

export function Invitacion() {
  const { code = '' } = useParams();
  const { session, acceptInviteAndAuth } = useAuth();
  const nav = useNavigate();
  const [invite, setInvite] = useState<PublicInvite | null>(null);
  const [loadErr, setLoadErr] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    api.invites
      .publicLookup(code)
      .then((inv) => live && setInvite(inv))
      .catch(() => live && setLoadErr('Esta invitación no existe o expiró.'));
    return () => {
      live = false;
    };
  }, [code]);

  async function join(register?: { name: string; email: string; password: string }) {
    setError(null);
    setBusy(true);
    try {
      const s = await acceptInviteAndAuth({ code, register });
      nav(homePathFor(s), { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo unir');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card style={{ width: '100%', maxWidth: 420 }}>
        {loadErr ? (
          <>
            <p style={{ color: 'var(--status-overdue)', fontWeight: 600 }}>{loadErr}</p>
            <Link to="/registro">Crear una cuenta</Link>
          </>
        ) : !invite ? (
          <p style={{ color: 'var(--text-hint)' }}>Cargando invitación…</p>
        ) : (
          <>
            <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--text-hint)', margin: 0 }}>Invitación</p>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-strong)', margin: '4px 0 4px' }}>{invite.orgName}</h1>
            <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>
              {invite.planName ? (
                <>
                  Plan <strong>{invite.planName}</strong>
                  {invite.price != null ? ` · $${invite.price}` : ''}
                </>
              ) : (
                'Te invitaron a unirte.'
              )}
            </p>
            {session ? (
              <Button fullWidth disabled={busy} onClick={() => join()}>{busy ? 'Uniéndote…' : 'Aceptar invitación'}</Button>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8 }}>
                <Input placeholder="Tu nombre" value={name} onChange={(e) => setName(e.currentTarget.value)} />
                <Input placeholder="Correo" type="email" value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
                <Input placeholder="Contraseña (mín. 8)" type="password" value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
                {error ? <p style={{ margin: 0, color: 'var(--status-overdue)', fontSize: 13, fontWeight: 600 }}>{error}</p> : null}
                <Button fullWidth disabled={busy || !name || !email || password.length < 8} onClick={() => join({ name, email, password })}>{busy ? 'Creando…' : 'Crear cuenta y unirme'}</Button>
                <p style={{ textAlign: 'center', margin: 0, fontSize: 13 }}>¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link> y vuelve a este enlace.</p>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}
